var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('h4',{staticClass:"text-center"},[_vm._v(" Website not found "),_c('br'),_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Back to home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }